<template>
  <div class="panel panel-default">
    <div class="panel-heading">
      <div class="row">
        <div class="col-md-4">
          <h5 class="panel-title">Other Transactions</h5>
        </div>
        <div class="col-md-6">
          <form class="form-inline form-inline--better-spaced form-inline--compact form-inline--one-liner" @submit.prevent.stop="searchOtherTransactions()">
            <div class="form-group from-group-sm" v-tooltip title="Refresh List">
              <label class="control-label sr-only">Reload</label>
              <button class="btn btn-xs" @click="searchOtherTransactions()" type="button">
                <span class="glyphicon glyphicon-refresh"></span>
              </button>
            </div>
            <div class="form-group from-group-sm" v-tooltip title="Filter by adding date">
              <label class="control-label sr-only">From Date</label>
              <select class="form-control input-sm" v-model="form.plusDate">
                <option v-for="(option, optionKey) in plusDateRangeOptions" :value="option.value" :key="optionKey">{{ option.label }}</option>
              </select>
            </div>
            <div class="form-group from-group-sm" v-tooltip title="Filter by subtracting date">
              <label class="control-label sr-only">To Date</label>
              <select class="form-control input-sm" v-model="form.minusDate">
                <option v-for="(option, key) in minusDateRangeOptions" :key="`${key}:${option.value}`" :value="option.value">{{ option.label }}</option>
              </select>
            </div>
            <div class="form-group from-group-sm" v-tooltip title="Filter batch number availablility">
              <label class="control-label sr-only">With or Without Batch</label>
              <select class="form-control input-sm" v-model="form.withBatch">
                <option v-for="(option, key) in withBatchOptions" :key="`${key}:${option.value}`" :value="option.value">{{ option.label }}</option>
              </select>
            </div>
          </form>
        </div>
        <div class="col-md-2 text-right">
          <div class="btn-group">
            <button class="btn btn-default btn-xs" @click="toggleVisibility()" v-show="visible" v-tooltip title="Hide transactions"><span class="glyphicon glyphicon-chevron-up"></span></button>
            <button class="btn btn-default btn-xs" @click="toggleVisibility()" v-show="!visible" v-tooltip title="Show transactions"><span class="glyphicon glyphicon-chevron-down"></span></button>
          </div>
        </div>
      </div><!-- .row -->
    </div><!-- .panel-heading -->
    <table class="table table-bordered table-hover table-condensed" v-show="visible">
      <thead>
        <tr>
          <th class="text-center" v-if="amountFinderStarted">
            <button class="btn btn-xs text-warning" type="button"
              @click="toggleAllSelection()"
              v-tooltip title="Select or unselect all transactions"
              >
              <span title="Select all" class="glyphicon glyphicon-ok" v-if="!isAllSelected" v-cloak></span>
              <span title="Unselect all" class="glyphicon glyphicon-remove" v-if="isAllSelected" v-cloak></span>
            </button>
          </th>
          <th class="col-md-2 text-center" st-sort="batchNumber">Batch #</th>
          <th class="col-md-1 text-center" st-sort="trxDateCreated" @click="toggleSort('datetime')">
            <i class="fa fa-fw fa-sort" v-show="!getSortMethod('datetime')"></i>
            <i class="fa fa-fw fa-sort-asc" v-show="'asc' === getSortMethod('datetime')"></i>
            <i class="fa fa-fw fa-sort-desc" v-show="'desc' === getSortMethod('datetime')"></i>
            Trx Date
          </th>
          <th class="col-md-1 text-center" st-sort="trxDocumentNumber" @click="toggleSort('documentNumber')">
            <i class="fa fa-fw fa-sort" v-show="!getSortMethod('documentNumber')"></i>
            <i class="fa fa-fw fa-sort-asc" v-show="'asc' === getSortMethod('documentNumber')"></i>
            <i class="fa fa-fw fa-sort-desc" v-show="'desc' === getSortMethod('documentNumber')"></i>
            Doc#
          </th>
          <th class="col-md-2" st-sort="trxMethod" @click="toggleSort('methodLabel')">
            <i class="fa fa-fw fa-sort" v-show="!getSortMethod('methodLabel')"></i>
            <i class="fa fa-fw fa-sort-asc" v-show="'asc' === getSortMethod('methodLabel')"></i>
            <i class="fa fa-fw fa-sort-desc" v-show="'desc' === getSortMethod('methodLabel')"></i>
            Method
            <select @click.stop v-model="filters.group">
              <option :value="null">All</option>
              <option v-for="(label, key) in groupFilters" :key="key" :value="label">{{ label }}</option>
            </select>
          </th>
          <th class="col-md-5" st-sort="customerName" @click="toggleSort('customerName')">
            <i class="fa fa-fw fa-sort" v-show="!getSortMethod('customerName')"></i>
            <i class="fa fa-fw fa-sort-asc" v-show="'asc' === getSortMethod('customerName')"></i>
            <i class="fa fa-fw fa-sort-desc" v-show="'desc' === getSortMethod('customerName')"></i>
            Customer
          </th>
          <th class="col-md-1 text-right" st-sort="trxAmount" @click="toggleSort('amount')">
            <i class="fa fa-fw fa-sort" v-show="!getSortMethod('amount')"></i>
            <i class="fa fa-fw fa-sort-asc" v-show="'asc' === getSortMethod('amount')"></i>
            <i class="fa fa-fw fa-sort-desc" v-show="'desc' === getSortMethod('amount')"></i>
            Amount$
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(trx, trxKey) in sortedAndFilteredOtherTransactions" :key="`${trxKey}:${trx.paymentId}`" @click="toggleSelection(trx)">
          <td class="text-center" v-if="amountFinderStarted"><span class="glyphicon glyphicon-ok" v-if="isSelected(trx)"></span></td>
          <td class="text-center">{{ trx.batchNumber }}</td>
          <td class="text-center">{{ trx.date | format('MM/DD/YYYY') }} {{ trx.dateCreated | format('HH:mm:ss') }}</td>
          <td class="text-center">
            <router-link v-if="trxIsPayment(trx) && trx.documentNumber" target="_blank" :to="`/admin/sales_order.php?oID=${trx.documentNumber}&action=view`"><i class="fa fa-fw fa-external-link"></i></router-link>
            {{ trxDocumentNumber(trx) }}
          </td>
          <td>
            <router-link v-if="trxIsPayment(trx) && trx.paymentId" target="_blank" :to="`/admin/sales-payment/view/${trx.paymentId}`"><i class="fa fa-fw fa-external-link"></i></router-link>
            {{ trxMethod(trx) }}
          </td>
          <td>{{ trx.customerName }}</td>
          <td class="text-right" :class="{'text-danger': trxAmount(trx) < 0}"><money currencySign="" :value="trxAmount(trx)"></money></td>
        </tr>
      </tbody>
    </table>
    <div class="panel-footer">
      <div class="row">
        <div class="col-md-6 text-right" v-if="amountFinderStarted">
          <strong>Selected: </strong> {{ totalSelected }}
        </div>
        <div class="col-md-3 text-right" :class="{'col-md-offset-6': !amountFinderStarted}">
          <strong>Total Items: </strong> {{ isFiltered ? totalFilteredTransactions : totalTransactions }}
        </div>
        <div class="col-md-3 text-right">
          <strong>Pay $ Total: </strong>
          <span v-if="!amountFinderStarted"><money currencySign="" :value="sumOfFilteredTransactions"></money></span>
          <span v-if="amountFinderStarted"><money currencySign="" :value="sumOfAllSelected"></money></span>
        </div>
      </div>
    </div><!-- .panel-footer -->
  </div><!-- .panel -->
</template>

<script>
  import _ from 'lodash'
  import { mapState, mapGetters } from 'vuex'
  import { format } from '@/plugin/filter/date'
  import moment from 'moment'
  import BatchMixin from '../../mixin/batch'
  import Money from '@/plugin/element/money'
  import Tooltip from '@/plugin/directive/tooltip'

  export default {
    name: 'other-transactions',
    data() {
      return {
        form: {
          plusDate: null,
          minusDate: null,
          withBatch: false
        },
        plusDateRangeOptions: [
          {value: null,  label: ''},
          {value: '1 d', label: '+ 1 Day'},
          {value: '3 d', label: '+ 3 Day'},
          {value: '1 w', label: '+ 1 Week'},
          {value: '2 w', label: '+ 2 Week'},
          {value: '3 w', label: '+ 3 Week'},
          {value: '1 M', label: '+ 1 Month'},
        ],
        minusDateRangeOptions: [
          {value: null, label: ''},
          {value: '1 d', label: '- 1 Day'},
          {value: '3 d', label: '- 3 Day'},
          {value: '1 w', label: '- 1 Week'},
          {value: '2 w', label: '- 2 Week'},
          {value: '3 w', label: '- 3 Week'},
          {value: '1 M', label: '- 1 Month'},
        ],
        withBatchOptions: [
          {value: false,  label: ''},
          {value: 'yes',  label: 'With Batch'},
          {value: 'no',   label: 'Without Batch'},
          {value: 'both', label: 'Both'},
        ],
        params: {
          postedTransactionsHidden: null
        },
        visible: true,
        sorters: {
          amount: 'desc'
        },
        filters: {
          method: null,
          group: null
        },
        enableFilterByMethod: false
      }
    },
    created() {
      if (this.enableFilterByMethod) {
        this.filters.method = localStorage['vue.admin.accounting.other-transactions.filters.method'] || null
      } else {
        this.filters.method = null
      }
      this.filters.group = localStorage['vue.admin.accounting.other-transactions.filters.group'] || null
    },
    watch: {
      // refresh transactions anytime the amount to find is changed
      // or reset form is amount to find is cleared
      amountFinderValue: _.debounce(function (val) {
        if (val) {
          this.searchOtherTransactions()
        } else {
          this.resetForm()
        }
      }, 1000),
      // refresh transactions everytime the transaction filter is changed
      form: {
        handler: _.debounce(function () {
          this.searchOtherTransactions()
        }, 500),
        deep: true
      },
      'filters.method'(val) {
        if (null === val || undefined === val) {
          if (localStorage['vue.admin.accounting.other-transactions.filters.method']) {
            delete localStorage['vue.admin.accounting.other-transactions.filters.method']
          }
        } else {
          localStorage['vue.admin.accounting.other-transactions.filters.method'] = val
        }
        this.unselectAllTransactions()
      },
      'filters.group'(val) {
        if (null === val || undefined === val) {
          if (localStorage['vue.admin.accounting.other-transactions.filters.group']) {
            delete localStorage['vue.admin.accounting.other-transactions.filters.group']
          }
        } else {
          localStorage['vue.admin.accounting.other-transactions.filters.group'] = val
        }
        this.unselectAllTransactions()
      }
    },
    computed: {
      ...mapState('paymentReconciliation/batch', {
        batchNumber: 'batchNumber'
      }),
      ...mapState('paymentReconciliation/amountFinder', {
        otherTransactions: 'otherTransactions',
        selectedTransactions: 'selectedOtherTransactions',
        amountFinderValue: 'amount'
      }),
      ...mapGetters('paymentReconciliation/amountFinder', {
        amountFinderStarted: 'started',
      }),
      sumOfAllTransactions() {
        return _.sumBy(this.otherTransactions, (trx) => {
          return this.trxAmount(trx)
        })
      },
      sumOfAllSelected() {
        return _.sumBy(this.selectedTransactions, (trx) => {
          return this.trxAmount(trx)
        })
      },
      sumOfFilteredTransactions() {
        return _.sumBy(this.sortedAndFilteredOtherTransactions, (trx) => {
          return this.trxAmount(trx)
        })
      },
      isAllSelected() {
        return this.totalSelected === this.totalTransactions
      },
      totalSelected() {
        return this.selectedTransactions.length
      },
      totalTransactions() {
        return this.otherTransactions.length
      },
      totalFilteredTransactions() {
        return this.sortedAndFilteredOtherTransactions.length
      },
      isAllFilteredSelected() {
        return ! (_.difference(
          this.sortedAndFilteredOtherTransactions, this.selectedTransactions
        ).length > 0)
      },
      isFiltered() {
        return !!this.filters.method || !!this.filters.group
      },
      sortedAndFilteredOtherTransactions() {
        let transactions = this.otherTransactions
        transactions = this.sortTransactions(transactions)
        transactions = this.filterTransactions(transactions)
        return transactions
      },
      methodFilters() {
        return _.chain(this.otherTransactions)
          .map((trx) => {
            let label = trx.methodName
            if (trx.methodClass) {
              label += ' ' + trx.methodClass
            }
            return label
          })
          .values()
          .thru((labels) => {
            const val = localStorage['vue.admin.accounting.other-transactions.filters.method']
            if (val) {
              labels.push(val)
            }
            return labels
          })
          .uniq()
          .sortBy((item) => {
            return [
              'Credit Card Visa',
              'Credit Card Master Card',
              'Credit Card Discover',
              'Credit Card American Express',
              'Fax Check',
              'NSF ACH',
              'NSF Check',
              'Check / Money Order',
              'Wire Transfer',
              'Paypal',
              'Cash',
              'Credit Card',
              'Check',
              'Open Account',
              'Customer Credit',
              'Account Debit',
            ].indexOf(item)
          })
          .map((item) => {
            if (-1 === item.indexOf('Credit Card')) {
              return item
            }

            return item.substring(12)
          })
          .value()
      },
      groupFilters() {
        return [
          'Credit Card',
          'ACH',
          'Checks & Money Order',
          'Wire Transfer',
          'Paypal',
          'Cash',
        ]
      }
    },
    methods: {
      toggleVisibility() {
        this.visible = !this.visible
      },
      toggleSelection(trx) {
        if (this.isSelected(trx)) {
          this.unselectTransaction(trx)
        } else {
          this.selectTransaction(trx)
        }
      },
      selectTransaction(trx) {
        this.$store.dispatch('paymentReconciliation/amountFinder/selectOtherTransaction', trx)
      },
      unselectTransaction(trx) {
        this.$store.dispatch('paymentReconciliation/amountFinder/unselectOtherTransaction', trx)
      },
      isSelected(trx) {
        return _.indexOf(this.selectedTransactions, trx) >= 0
      },
      toggleAllSelection() {
        if (this.isFiltered) {
          if (this.isAllFilteredSelected) {
            this.unselectFilteredTransactions()
          } else {
            this.selectFilteredTransactions()
          }
        } else {
          if (this.isAllSelected) {
            this.unselectAllTransactions()
          } else {
            this.selectAllTransactions()
          }
        }
      },
      selectAllTransactions() {
        this.$store.dispatch('paymentReconciliation/amountFinder/selectAllOtherTransaction')
      },
      unselectAllTransactions() {
        this.$store.dispatch('paymentReconciliation/amountFinder/unselectAllOtherTransaction')
      },
      selectFilteredTransactions() {
        _.each(this.sortedAndFilteredOtherTransactions, (trx) => {
          this.selectTransaction(trx)
        })
      },
      unselectFilteredTransactions() {
        _.each(this.sortedAndFilteredOtherTransactions, (trx) => {
          this.unselectTransaction(trx)
        })
      },
      searchOtherTransactions() {
        const excludeBatch = this.batchNumber
        const withBatch    = this.form.withBatch

        let fromDate = ''
        let toDate   = ''

        const mDate = moment(this.batchNumber, 'YYMMDD')
        if (this.form.plusDate) {
          toDate = this.form.plusDate.split(' ')
          toDate = mDate.clone().add(toDate[0], toDate[1]).toISOString()
        }
        if (this.form.minusDate) {
          fromDate = this.form.minusDate.split(' ')
          fromDate = mDate.clone().subtract(parseInt(fromDate[0]), fromDate[1]).toISOString()
        }
        if (!fromDate && !toDate) {
          fromDate = moment().add(-1, 'months').toISOString()
          toDate = moment().add(-2, 'days').toISOString()
        }

        this.$store.dispatch('paymentReconciliation/amountFinder/findAnyTransaction', {excludeBatch, fromDate, toDate, withBatch})
      },
      resetForm() {
        this.form.plusDate  = null
        this.form.minusDate = null
        this.form.withBatch = false
      },
      toggleSort(col) {
        let val = this.sorters[col]

        this.sorters = {}

        if (val) {
          if ('asc' === val) {
            this.$set(this.sorters, col, 'desc')
          } else if ('desc' === val) {
            this.$set(this.sorters, col, 'asc')
          }
        } else {
          this.$set(this.sorters, col, 'asc')
        }
      },
      getSortMethod(col) {
        return this.sorters[col]
      },
      sortTransactions(transactions) {
        if (_.isEmpty(this.sorters)) {
          return transactions
        }

        let columns = _.keys(this.sorters)
        let orders = _.values(this.sorters)

        if (1 === columns.length) {
          let methodLabelIndex = _.indexOf(columns, 'methodLabel')
          if (methodLabelIndex >= 0) {
            columns.push('amount')
            if ('desc' === orders[methodLabelIndex]) {
              orders.push('asc')
            } else {
              orders.push('desc')
            }
          }
        }

        columns = _.map(columns, (col) => {
          if ('methodLabel' !== col) {
            return col
          }
          return (item) => {
            return [
              'Visa',
              'Master Card',
              'Discover',
              'American Express',
              'Fax Check',
              'NSF ACH',
              'NSF Check',
              'Check / Money Order',
              'Wire Transfer',
              'Paypal',
              'Cash',
              'Credit Card',
              'Check',
              'Open Account',
              'Customer Credit',
              'Account Debit',
            ].indexOf(this.trxMethod(item))
          }
        })

        columns = _.map(columns, (col) => {
          if ('datetime' !== col) {
            return col
          }
          return (item) => {
            let date = item.date
            let time = moment(item.dateCreated, 'YYYY-MM-DD HH:mm:ss').format('HH:mm:ss')
            return `${date} ${time}`
          }
        })

        return _.chain(transactions).orderBy(columns, orders).value()
      },
      filterTransactions(transactions) {
        return _.chain(transactions)
          .filter((trx) => {
            if (!this.filters.method) {
              return true
            }

            return trx.methodName === this.filters.method || trx.methodClass === this.filters.method
          })
          .filter((trx) => {
            if (!this.filters.group) {
              return true
            }
            if ('All' === this.filters.group) {
              return true
            }

            let keep = false
            switch (this.filters.group) {
              case 'Credit Card':
                keep = trx.methodName === 'Credit Card'
                break
              case 'ACH':
                keep = _.indexOf(['Fax Check', 'Account Debit'], trx.methodName) >= 0
                break
              case 'Checks & Money Order':
                keep = _.indexOf(['Check', 'Check / Money Order'], trx.methodName) >= 0
                break
              case 'Wire Transfer':
                keep = trx.methodName === 'Wire Transfer'
                break
              case 'Paypal':
                keep = trx.methodName === 'Paypal'
                break
              case 'Cash':
                keep = trx.methodName === 'Cash'
                break
            }

            return keep
          })
          .value()
      },
      transactionTimeCreated(trx) {
        moment(trx.dateCreated).format('hh:mm:ss')
      }
    },
    components: {
      Money
    },
    directives: {
      tooltip: Tooltip
    },
    filters: {
      format
    },
    mixins: [
      BatchMixin
    ]
  }
</script>
